let formattingLocale: string | undefined;
let formattingDateLocale: string | undefined;
let formattingCurrencyCode: string | undefined;

export interface FormattingSettings {
  currencyCode?: string;
  currencySymbol?: string;
  currencyDigits?: number;
  numberFormat?: {
    decimalSeparator?: string;
    thousandsSeparator?: string;
    grouping?: string;
  };
  measurementSystem?: string;
  unitsOfMeasure?: import('./units').PropertyUnitsOfMeasure;
  unitOfMeasureForArea?: string;
  unitOfMeasureForWeight?: string;
  unitOfMeasureForDistance?: string;
}

let formattingSettings: FormattingSettings | undefined;

export function setFormattingLocale(locale: string | undefined): void {
  formattingLocale = locale;
}

export function getFormattingLocale(): string | undefined {
  return formattingLocale;
}

export function setFormattingDateLocale(locale: string | undefined): void {
  formattingDateLocale = locale?.replace(/_/g, '-');
}

export function getFormattingDateLocale(): string | undefined {
  return formattingDateLocale;
}

export function setFormattingCurrencyCode(currencyCode: string | undefined): void {
  formattingCurrencyCode = currencyCode;
}

export function getFormattingCurrencyCode(): string | undefined {
  return formattingSettings?.currencyCode ?? formattingCurrencyCode;
}

export function setFormattingSettings(settings: FormattingSettings | undefined): void {
  formattingSettings = settings;
  formattingCurrencyCode = settings?.currencyCode;
}

export function getFormattingSettings(): FormattingSettings | undefined {
  return formattingSettings;
}

export function resetFormattingLocale(): void {
  formattingLocale = undefined;
  formattingDateLocale = undefined;
  formattingCurrencyCode = undefined;
  formattingSettings = undefined;
}
